import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { getCommercialStructureData } from 'services/app/commercialStructure'
import { Office } from 'services/app/commercialStructure/interfaces'
import { AppThunk } from 'store/store'

type InitialStateType = {
  loadingStructure: boolean
  comercialStructure: Office[]
}

const initialState: InitialStateType = {
  loadingStructure: false,
  comercialStructure: [] as Office[]
}

const management = createSlice({
  name: 'management',
  initialState,
  reducers: {
    setLoadingStructure(state, action: PayloadAction<boolean>) {
      state.loadingStructure = action.payload
    },
    setComercialStructure(state, action: PayloadAction<Office[]>) {
      state.comercialStructure = action.payload
    }
  }
})

export const { setLoadingStructure, setComercialStructure } = management.actions

export const managementContext = management.reducer

export const getComercialStructure = (): AppThunk => async (dispatch) => {
  dispatch(setLoadingStructure(true))

  try {
    const structure = await getCommercialStructureData(0)

    dispatch(setComercialStructure(structure))
  } catch (error) {
    toast.error('Erro ao carregar estrutura comercial.')
  } finally {
    dispatch(setLoadingStructure(false))
  }
}
